import { FC, InputHTMLAttributes } from "react";
import { locale } from "src/config/app-config";
import { getCurrencySymbol } from "src/utils/getCurrencySymbol";
import { Currency, Input, Wrapper } from "./CurrencyInput.styled";

const CurrencyInput: FC<InputHTMLAttributes<HTMLInputElement>> = (props) => {
  const currency = getCurrencySymbol(locale);
  return (
    <Wrapper>
      <Input type="number" {...props} currencyLength={currency.length} />
      <Currency>{currency}</Currency>
    </Wrapper>
  );
};

export default CurrencyInput;
